import { ICheckoutModel } from "../";

export default function getCheckout(
    promotionId?: number,
    promotionCode?: string
): ICheckoutModel {
    return {
        promotionId: promotionId || 0,
        promotionCode: promotionCode || "",
        email: "",
        shippingAddress: {
            address: "",
            address2: "",
            city: "",
            firstName: "",
            lastName: "",
            phone: "",
            state: "",
            zipCode: ""
        },
        billingAddressSameAsShipping: true,
        billingAddress: {
            address: "",
            address2: "",
            city: "",
            firstName: "",
            lastName: "",
            phone: "",
            state: "",
            zipCode: ""
        },
        paymentMethod: 0,
        cardNumber: "",
        expirationDateMonth: null,
        expirationDateYear: null,
        get expirationDate(): string | null {
            if (!this.expirationDateMonth || !this.expirationDateYear) {
                return null;
            }
            return new Date(
                this.expirationDateYear,
                // the js month parameter is an index - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/Date#syntax
                this.expirationDateMonth - 1
            ).toDateString();
        },
        cvvCode: "",
        acceptedTermsAndConditions: false,
        emailOptIn: true,

        upsellIds: [],

        // Gets the promotion URL used to load the promotion (current URL)
        // to send to the Zapier integration upon order submission.
        promotionUrl: window.location.href,
        paymentMethodCode: "",

        //Used to contain the CommissionJunction cjevent query string parameter if it exists
        cjEvent: "",

        // UTM marketing parameters
        utmSource: "",
        utmContent: "",
        utmCampaign: "",
        utmMedium: "",
        source: "",

        // the fbclid query string param
        facebookClickId: "",

        sessionId: ""
    };
}
